module.exports = __webpack_public_path__ + "img/etoak.2a4547a1.png";